import React from 'react';
import Button from '../../components/Button';
import { useMutation } from 'react-apollo-hooks';
import { UPDATE_MEMBER_STATUS } from '../../common/graphql/UpdateMemberStatus';
import { GET_MEMBER_WITH_COGNITO_USER } from '../../common/graphql/GetMember';

export default function StatusButton(props) {
  const { classes, disabled, memberData } = props;
  const isActive = memberData.get('inactive') !== true;
  const [loading, setLoading] = React.useState(false);

  const updateMemberStatus = useMutation(UPDATE_MEMBER_STATUS.mutation, {
    refetchQueries: () => [GET_MEMBER_WITH_COGNITO_USER.key],
  });

  const handlers = {
    async onButtonClick() {
      setLoading(true);
      const variables = {
        memberId: memberData.get('id'),
        inactive: isActive,
        status: isActive ? 'INACTIVE' : 'ACTIVE',
      };
      await updateMemberStatus({
        variables,
      });
      setLoading(false);
    },
  };

  return (
    <Button
      size="large"
      disabled={disabled || loading}
      classes={classes}
      variant="contained"
      onClick={handlers.onButtonClick}
    >
      {isActive ? 'Deactivate' : 'Activate'}
    </Button>
  );
}
